import { FundamentalsMetrics, RiskMetrics, RiskOverviewMetrics } from '../../models/RiskProducts';
import useFetchFundamentals from './useFetchFundamentals';
import useFetchRiskOverview from './useFetchRiskOverview';
import useFetchRiskProducts from './useFetchRiskProducts';

interface useGetRiskDataResult {
  riskMetrics: RiskMetrics;
  riskOverviewMetrics: RiskOverviewMetrics | undefined;
  fundamentalsMetrics: FundamentalsMetrics | undefined;
  isLoading: boolean;
  isError: boolean;
  refetch: () => void;
}

export default (companyId: string): useGetRiskDataResult => {
  const {
    data: riskMetrics,
    isLoading: isLoadingRiskMetrics,
    isError: isRiskMetrcicsError,
    refetch: refetchRiskMetrics,
  } = useFetchRiskProducts(companyId);
  const {
    data: riskOverviewMetrics,
    isLoading: isLoadingRiskOverviewMetrics,
    isError: isRiskOverviewMetricsError,
    refetch: refetchRiskOverviewMetrics,
  } = useFetchRiskOverview(companyId);
  const {
    data: fundamentalsMetrics,
    isLoading: isLoadingFundamentalsMetrics,
    isError: isFundamentalsError,
    refetch: refetchFundamentalsMetrics,
  } = useFetchFundamentals(companyId);

  const refetch = () => {
    if (isRiskOverviewMetricsError) {
      refetchRiskOverviewMetrics();
    }
    if (isRiskMetrcicsError) {
      refetchRiskMetrics();
    }
    if (isFundamentalsError) {
      refetchFundamentalsMetrics();
    }
  };

  return {
    riskMetrics,
    riskOverviewMetrics,
    fundamentalsMetrics,
    isLoading: isLoadingRiskMetrics || isLoadingRiskOverviewMetrics || isLoadingFundamentalsMetrics,
    isError: isRiskOverviewMetricsError || isRiskMetrcicsError || isFundamentalsError,
    refetch,
  };
};
